import * as React from 'react';
import { useSelector } from 'react-redux';
import { TAreaInputComponentProps } from 'shared/common/utils/types';
import { selectFormFields, selectEstimationTarget, selectIsNewbuilding } from '../../selectors';
import { useActions } from '../useActions';
import { ECurrentErrorField, EUnits } from '../../types/formFields';
import { intOnly } from '../../utils/intOnly';
import { getTrackMyHomeAreaPick } from '../tracking';

/** Пропсы для фильтра площади квартиры */
export const useAreaInputProps = (): TAreaInputComponentProps => {
  const { area, errorTooltip, userSetArea } = useSelector(selectFormFields);
  const estimationTarget = useSelector(selectEstimationTarget);
  const isNewbuilding = useSelector(selectIsNewbuilding);

  const { setError, setUserAreaFlag, setArea } = useActions();

  /** Если есть ошибка, отобразится над инпутом фильтра */
  const errorMessage = errorTooltip.currentErrorField === ECurrentErrorField.area ? errorTooltip.errorText : '';

  /** Обработчик ввода в инпут Площади */
  const onValueChange = React.useCallback<TAreaInputComponentProps['onValueChange']>(
    value => {
      const intVal = intOnly(value);

      setArea(Number(intVal));

      if (!userSetArea) {
        setUserAreaFlag(true);
      }

      if (errorMessage) {
        setError({ currentErrorField: ECurrentErrorField.area, errorText: '' });
      }
    },
    [errorMessage, userSetArea, setArea, setError, setUserAreaFlag],
  );

  const shouldShowUnit = Boolean(area);

  return {
    value: area ? String(area) : '',
    unit: EUnits.area,
    errorMessage,
    onValueChange,
    shouldShowUnit,
    onBlur: getTrackMyHomeAreaPick({
      estimationTarget,
      value: String(area),
      auto: false,
      isNewbuilding,
    }),
  };
};
